import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Collapse } from 'reactstrap';
// Import Data
import navdata from "../LayoutMenuData";
import { withTranslation } from "react-i18next";
import withRouter from "../../Components/Common/withRouter";
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';
import { Progress } from "reactstrap";
import axios from 'axios';
import { getCurrentUser } from 'aws-amplify/auth';


const VerticalLayout = (props) => {
    const navData = navdata().props.children;
    const path = props.router.location.pathname;
    const [storageUsed, setStorageUsed] = useState();
    const [plan, setPlan] = useState(""); // Placeholder for plan
    const [bandwidth, setBandwidth] = useState(); // Placeholder for bandwidth
    const [totalStorage, setTotalStorage] = useState();  // Total storage in GB
    const [totalBandwidth, setTotalBandwidth] = useState();  // Total bandwidth in GB
    const [storage_used, setStorage_Used] = useState(0);
    const [bandwidth_used, setBandwidth_Used] = useState(0);
    const [storageQuota, setStorageQuota] = useState();
    const [bandwidthQuota, setBandwidthQuota] = useState();
    const profileData = useSelector((state) => state.Profile.profileData); 
    // console.log(" p d v",profileData);
    
    /*
 layout settings
 */
    useEffect(() => {
        const fetchData = async () => {
            const user = await getCurrentUser();
            const cognito_id = user.userId;
         

            try {
               
              

                const convertToReadableFormat = (valueInBytes) => {
                    if (valueInBytes < 1024) {
                        return `${valueInBytes} Bytes`; 
                    } else if (valueInBytes < 1048576) {  
                        return `${(valueInBytes / 1024).toFixed()} KB`;
                    } else if (valueInBytes < 1073741824) {  
                        return `${(valueInBytes / 1048576).toFixed()} MB`;
                    } else if (valueInBytes < 1099511627776) {  
                        return `${(valueInBytes / 1073741824).toFixed()} GB`;
                    } else {  
                        return `${(valueInBytes / 1099511627776).toFixed(2)} TB`;
                    }
                };

                
                const storageUsed = convertToReadableFormat(profileData?.result?.storage_used || 0);
                const bandwidthUsed = convertToReadableFormat(profileData?.result?.bandwidth_used || 0);
                const storageQuota = convertToReadableFormat(profileData?.result?.storage_quota || 0);
                const bandwidthQuota = convertToReadableFormat(profileData?.result?.bandwidth_quota || 0);


                setStorageUsed(storageUsed);  // Example: updating storage used
                setPlan(profileData?.result?.current_plan?.plan_name  || profileData?.result?.current_plan);           // Example: updating plan
                setBandwidth(bandwidthUsed); // Example: updating bandwidth
                setStorageQuota(storageQuota);
                setBandwidthQuota(bandwidthQuota);

                setStorage_Used (profileData?.result?.storage_used);
                setBandwidth_Used (profileData?.result?.bandwidth_used);
                setTotalStorage (profileData?.result?.storage_quota);
                setTotalBandwidth (profileData?.result?.bandwidth_quota);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        fetchData();
    }, [profileData]);

    const progress1 = (storage_used/totalStorage)*100;
    const progress2 = (bandwidth_used/totalBandwidth)*100;
   
    const selectLayoutState = (state) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            leftsidbarSizeType: layout.leftsidbarSizeType,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
            layoutType: layout.layoutType
        })
    );

    const {
        leftsidbarSizeType, sidebarVisibilitytype, layoutType
    } = useSelector(selectLayoutProperties);

    //vertical and semibox resize events
    const resizeSidebarMenu = useCallback(() => {
        var windowSize = document.documentElement.clientWidth;
        if (windowSize >= 1025) {
            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }
            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }
            if ((sidebarVisibilitytype === "show" || layoutType === "vertical" || layoutType === "twocolumn") && document.querySelector(".hamburger-icon")) {
                var hamburgerIcon = document.querySelector(".hamburger-icon");
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.remove("open");
                }
            } else {
                var hamburgerIcon = document.querySelector(".hamburger-icon");
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.add("open");
                }
            }

        } else if (windowSize < 1025 && windowSize > 767) {
            document.body.classList.remove("twocolumn-panel");
            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", "sm");
            }
            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", "sm");
            }
            if (document.querySelector(".hamburger-icon")) {
                document.querySelector(".hamburger-icon").classList.add("open");
            }
        } else if (windowSize <= 767) {
            document.body.classList.remove("vertical-sidebar-enable");
            if (document.documentElement.getAttribute("data-layout") !== "horizontal") {
                document.documentElement.setAttribute("data-sidebar-size", "lg");
            }
            if (document.querySelector(".hamburger-icon")) {
                document.querySelector(".hamburger-icon").classList.add("open");
            }
        }
    }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

    useEffect(() => {
        window.addEventListener("resize", resizeSidebarMenu, true);
    }, [resizeSidebarMenu]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + path;
            const ul = document.getElementById("navbar-nav");
            const items = ul.getElementsByTagName("a");
            let itemsArray = [...items]; // converts NodeList to Array
            removeActivation(itemsArray);
            let matchingMenuItem = itemsArray.find((x) => {
                return x.pathname === pathName;
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        initMenu();
    }, [path, props.layoutType]);

    const updatedMenu = (item) => (event) => {
        event.preventDefault();
        const anchorTag = event.target.closest('a');
        anchorTag.classList.add("active");

        let parentCollapseDiv = anchorTag.nextElementSibling;
        
        if (parentCollapseDiv) {

            // Add 'show' class to the clicked menu's parent collapse div
            parentCollapseDiv.classList.toggle("show");

            // Set aria-expanded attribute
            const isExpanded = parentCollapseDiv.classList.contains("show");
            anchorTag.setAttribute("aria-expanded", isExpanded ? "true" : "false");

            // Add 'active' class to the clicked menu's parent element
            parentCollapseDiv.parentElement.children[0].classList.add("active");

            // Additional logic to handle parent collapses
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
                }
            }
            return false;
        }
        return false;
    };

    function activateParentDropdown(item) {
        item?.classList?.add("active");
        let parentCollapseDiv = item?.closest(".collapse.menu-dropdown");

        if (parentCollapseDiv) {
            // to set aria expand true remaining
            parentCollapseDiv.classList.add("show");
            parentCollapseDiv.parentElement.children[0].classList.add("active");
            parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
                parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.setAttribute("aria-expanded", "true");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.setAttribute("aria-expanded", "true");
                }
            }
            return false;
        }
        return false;
    }

    const removeActivation = (items) => {
        
        let actiItems = items.filter((x) => x.classList.contains("active"));

        actiItems.forEach((item) => {
            if (item.classList.contains("menu-link")) {
                if (!item.classList.contains("active")) {
                    item.setAttribute("aria-expanded", false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
            }
            if (item.classList.contains("nav-link")) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("active");
        });
    };

    return (
        <React.Fragment>
            {/* menu Items */}
            {(navData || []).map((item, key) => {
                return (
                    <React.Fragment key={key}>
                        {/* Main Header */}
                        {item['isHeader'] ?
                            <li className="menu-title"><span data-key="t-menu">{props.t(item.label)} </span></li>
                            : (
                                (item.subItems ? (
                                    <li className="nav-item">
                                        <Link
                                            onClick={item.isDisabled ? (e) => e.preventDefault() : updatedMenu(item)}
                                            className={`nav-link menu-link ${item.isDisabled ? 'disabled' : ''}`}
                                            to={item.link ? item.link : "/#"}
                                            data-bs-toggle={item.isDisabled ? undefined : "collapse"}
                                            style={item.isDisabled ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
                                        >
                                            <i className={item.icon}></i>
                                            <span data-key="t-apps">
                                                {props.t(item.label)}
                                                {item.labelSubtitle && (
                                                    <span style={{ display: 'block', fontStyle: 'italic', fontSize: '0.85em', marginTop: '2px' }}>
                                                        {item.labelSubtitle}
                                                    </span>
                                                )}
                                            </span>
                                            {item.badgeName ?
                                                <span className={"badge badge-pill bg-" + item.badgeColor} data-key="t-new">{item.badgeName}</span>
                                                : null}
                                        </Link>
                                        <Collapse
                                            className="menu-dropdown"
                                            isOpen={item.stateVariables}
                                            id="sidebarApps">
                                            <ul className="nav nav-sm flex-column test">
                                                {/* subItms  */}
                                                {item.subItems && ((item.subItems || []).map((subItem, key) => (
                                                    <React.Fragment key={key}>
                                                        {!subItem.isChildItem ? (
                                                            <li className="nav-item">
                                                                <Link
                                                                    to={subItem.link ? subItem.link : "/#"}
                                                                    className="nav-link"
                                                                >
                                                                    {props.t(subItem.label)}
                                                                    {subItem.badgeName ?
                                                                        <span className={"badge badge-pill bg-" + subItem.badgeColor} data-key="t-new">{subItem.badgeName}</span>
                                                                        : null}
                                                                </Link>
                                                            </li>
                                                        ) : (
                                                            <li className="nav-item">
                                                                <Link
                                                                    onClick={updatedMenu(subItem)}
                                                                    className="nav-link"
                                                                    to="/#"
                                                                    data-bs-toggle="collapse"
                                                                >
                                                                    {props.t(subItem.label)}
                                                                    {subItem.badgeName ?
                                                                        <span className={"badge badge-pill bg-" + subItem.badgeColor} data-key="t-new">{subItem.badgeName}</span>
                                                                        : null}
                                                                </Link>
                                                                <Collapse className="menu-dropdown" isOpen={subItem.stateVariables} id="sidebarEcommerce">
                                                                    <ul className="nav nav-sm flex-column">
                                                                        {/* child subItms  */}
                                                                        {subItem.childItems && (
                                                                            (subItem.childItems || []).map((childItem, key) => (
                                                                                <React.Fragment key={key}>
                                                                                    {!childItem.childItems ?
                                                                                        <li className="nav-item">
                                                                                            <Link
                                                                                                to={childItem.link ? childItem.link : "/#"}
                                                                                                className="nav-link">
                                                                                                {props.t(childItem.label)}
                                                                                            </Link>
                                                                                        </li>
                                                                                        : <li className="nav-item">
                                                                                            <Link to="/#" className="nav-link" onClick={updatedMenu(childItem)} data-bs-toggle="collapse">
                                                                                                {props.t(childItem.label)}
                                                                                            </Link>
                                                                                            <Collapse className="menu-dropdown" isOpen={childItem.stateVariables} id="sidebaremailTemplates">
                                                                                                <ul className="nav nav-sm flex-column">
                                                                                                    {childItem.childItems.map((subChildItem, key) => (
                                                                                                        <li className="nav-item" key={key}>
                                                                                                            <Link to={subChildItem.link} className="nav-link" data-key="t-basic-action">{props.t(subChildItem.label)} </Link>
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </Collapse>
                                                                                        </li>
                                                                                    }
                                                                                </React.Fragment>
                                                                            ))
                                                                        )}
                                                                    </ul>
                                                                </Collapse>
                                                            </li>
                                                        )}
                                                    </React.Fragment>
                                                ))
                                                )}
                                            </ul>

                                        </Collapse>
                                    </li>
                                ) : (
                                    <li className="nav-item">
                                        <Link
                                            className={`nav-link menu-link ${item.isDisabled ? 'disabled' : ''}`}
                                            to={item.link ? item.link : "#"}
                                            onClick={item.isDisabled ? (e) => e.preventDefault() : undefined}
                                            style={item.isDisabled ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
                                        >
                                            <i className={item.icon}></i> 
                                            <span>
                                                {props.t(item.label)}
                                                {item.labelSubtitle && (
                                                    <span style={{ display: 'block', fontStyle: 'italic', fontSize: '0.85em', marginTop: '2px' }}>
                                                        {item.labelSubtitle}
                                                    </span>
                                                )}
                                            </span>
                                            {item.badgeName ?
                                                <span className={"badge badge-pill bg-" + item.badgeColor} data-key="t-new">{item.badgeName}</span>
                                                : null}
                                        </Link>
                                    </li>
                                ))
                            )
                        }
                    </React.Fragment>
                );
            })}
            <div className="storage-progress" style={styles.progressContainer}>
                <div className="d-flex justify-content-between mt-2">
                    <span>Plan : {plan}</span>
                </div>
                <div style={{  justifyContent: "space-between" }}>
                    <span>Storage Used :  </span>
                    <span>{storageUsed}  /  {storageQuota}</span>
                </div>
                <Progress value={progress1} style={{ height: "8px" }} color="primary" />
                <div className="d-flex justify-content-between mt-3">
                    <span>Bandwidth : {bandwidth}/{bandwidthQuota}</span>
                </div>
                <Progress value={progress2} style={{ height: "8px" }} color="primary" />


            </div>
        </React.Fragment>
    );
};

VerticalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};
const styles = {
    navdataContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh', // Full height of the screen
        justifyContent: 'space-between', // Ensure progress bar sticks to bottom
        padding: '10px',
    },
    progressContainer: {
        padding: '10px 30px',
        position: 'absolute',
        bottom: '0',
        color: 'white',

    },
};
export default withRouter(withTranslation()(VerticalLayout));
